import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as reportAction from './../../../../../actions/reportAction';
import VoucherRedeemtionReports from './VoucherRedeemtionReports';

const mapStateToProps = state => {
    return {
        reportState: state.reportReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getVoucherRedeemtionReport: (filters) => dispatch(reportAction.getVoucherRedeemtionReport(filters)),
        getVoucherRedeemtionReportDetail: (filters) => dispatch(reportAction.getVoucherRedeemtionReportDetail(filters)),
        exportExcel: (filters) => dispatch(reportAction.exportVoucherRedeemtions(filters))
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(VoucherRedeemtionReports));
